class ViewRenderTracker {
  wasRenderedByServer = true

  get value() {
    // we only want to return 'server' the first time the value is read
    if (this.wasRenderedByServer) {
      this.wasRenderedByServer = false
      return 'server'
    }
    return 'client'
  }
}

export default new ViewRenderTracker()
